import { CARD_SIZE, COLUMNS, FREE_INDEX, cardColumnIndex, pad } from '@bingo/shared';

/**
 * Cartela da conferência no telão (decisão 8 do CLAUDE.md).
 *
 * Quem está na plateia precisa ver a conferência acontecendo — senão o bingo
 * "é confirmado nos bastidores" e a casa perde a confiança do salão. Então o
 * telão mostra os 25 números digitados, com os que saíram pintados, os que
 * faltam em vermelho e o padrão vencedor contornado de dourado.
 */

export function ClaimCardOverlay({
  title,
  detail,
  warning,
  cells,
  drawn,
  freeCenter,
  winningIndices,
  cardNumber,
}: {
  title: string;
  detail: string;
  warning?: string;
  cells: readonly (number | null)[];
  drawn: readonly number[];
  freeCenter: boolean;
  winningIndices: readonly number[];
  cardNumber: string | null;
}) {
  const drawnSet = new Set(drawn);
  const winning = new Set(winningIndices);

  return (
    <div className="tv-claim">
      <div className="tv-claim-inner">
        <h2>
          {title}
          {cardNumber ? ` · cartela ${cardNumber}` : ''}
        </h2>

        <div className="card">
          {COLUMNS.map((column) => (
            <div
              key={column.letter}
              className="h"
              style={{ '--c': column.color } as React.CSSProperties}
            >
              {column.letter}
            </div>
          ))}

          {Array.from({ length: CARD_SIZE }, (_, index) => {
            const column = COLUMNS[cardColumnIndex(index)]!;
            const value = cells[index];
            const free = freeCenter && index === FREE_INDEX;

            const classes = ['cc'];
            if (free) classes.push('free');
            else if (typeof value === 'number') {
              classes.push(drawnSet.has(value) ? 'hit' : 'miss');
            }
            if (winning.has(index)) classes.push('win');

            return (
              <div
                key={index}
                className={classes.join(' ')}
                style={{ '--c': column.color } as React.CSSProperties}
              >
                {free ? 'LIVRE' : typeof value === 'number' ? pad(value) : ''}
              </div>
            );
          })}
        </div>

        <p style={{ margin: 0, color: 'var(--muted)', fontSize: 'clamp(13px,2.2vh,26px)' }}>
          {detail}
        </p>
        {warning ? (
          <p
            style={{
              margin: 0,
              color: 'var(--gold)',
              fontWeight: 700,
              fontSize: 'clamp(12px,2vh,22px)',
              maxWidth: '40ch',
              textAlign: 'center',
            }}
          >
            {warning}
          </p>
        ) : null}
      </div>
    </div>
  );
}

/** Faixa de "Bingo não confirmado · O jogo continua". */
export function Banner({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <div className="banner" id="banner">
      <div>
        {title}
        <small>{subtitle}</small>
      </div>
    </div>
  );
}
